import { supabase } from "../supabase"


export const fetchAskersCategoryThemes = () => {
    return supabase
    .from("askers_category_themes")
    .select("*")
    .order("created_at", { ascending: false })
}

export const updateAskersCategoryTheme = (themeId: number, themeData: unknown) => {
    return supabase
          .from('askers_category_themes')
          .update(themeData)
          .eq('id', themeId);
}

export const createAskersCategoryTheme = (themeData: unknown) => {
    return supabase.from('askers_category_themes').insert(themeData);

}

export const deleteAskersCategoryTheme = (themeId: number) => {
    return supabase
          .from('askers_category_themes')
          .delete().eq('id', themeId);
}